import { Injectable } from "@angular/core";

import { CoreHttpClient } from "../http-client/http-client.service";

import { GameSessionConfigService } from "./game-session.config";
import { CloseGameSessionPayload, CloseGameSessionResponse } from "./game-session.model";

@Injectable({
	providedIn: "root",
})
export class GameSessionService {
	constructor(
		private httpClient: CoreHttpClient,
		private gameSessionConfigService: GameSessionConfigService
	) {}

	closeGameSession(payload: CloseGameSessionPayload) {
		return this.httpClient.post<CloseGameSessionResponse>({
			url: this.gameSessionConfigService.getGameSessionCloseEndpoint(),
			data: payload,
		});
	}
}
